exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".employee-item[data-v-21370240]{cursor:pointer}.selected[data-v-21370240]{background:#005086;color:#fff}.bot-line[data-v-21370240]{border-bottom:5px solid #000}", ""]);

// exports
